import { gql } from '@apollo/client';

const USER_FRAGMENT = gql`
  fragment BaseUser on User {
    id
    username
    firstName
    lastName
    type
    pin
    avatarUrl
    status
    dateUpdated
    sisId
    licenseUsage {
      assignedCount
      trial
      product {
        id
        code
        name
        iconUrl
        family {
          id
          code
          name
          iconUrl
        }
      }
      productCurriculum {
        id
        code
        name
        iconUrl
      }
    }
  }
`;

export default USER_FRAGMENT;
